import BrandExposureGlyph from './brand-exposure.svg'
import GolfAccessGlyph from './golf-access.svg'
import GuestOpportunitiesGlyph from './guest-opportunities.svg'
import NetworkingEventsGlyph from './networking-events.svg'
import NetworkingServiceGlyph from './networking-service.svg'
import TeamWellbeingGlyph from './team-wellbeing.svg'

export {
  BrandExposureGlyph,
  GolfAccessGlyph,
  GuestOpportunitiesGlyph,
  NetworkingEventsGlyph,
  NetworkingServiceGlyph,
  TeamWellbeingGlyph,
}
